export * from './queues.component'
export * from './queue-create.component'
export * from './queue-details.component'
export * from './queue-delete.component'
export * from './queue-edit.component'
export * from './queues.route'



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/management/queues/index.ts